import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { NotificationManager } from "../common/react-notifications";
import FormCustom from "../../components/utils/FormCustom";
import Dialog from "../../components/utils/Dialog";
import _axios from "../../libs/axios";
import {debounce} from "lodash";

export default class AiAssist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progressBar: false,
      aiModal: false,
      aiText: null,
      form: null,
      formFields: [],
      dialog: {
        isOpen: false,
        toggle: () => {},
        title: null,
        msg: null,
        confirm: () => {}
      }
    }
  }

  postInputMax = debounce(() => { this.write(true) }, 400)

  UNSAFE_componentWillMount() {
    this.createForm()
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  componentWillUnmount() {
  }

  execute = () => {
    const action = this.props.field.aiAssist.action
    if (action === 'translate') this.translate()
    else if (action === 'write') this.write()
  }

  createForm () {
    const fields = [
      {
        col: 12,
        name: "summarize",
        type: "radioGroup",
        value: "",
        label: "main.summarize",
        opts: {
          list: [
            {value: "1", label: "main.short"},
            {value: "2", label: "main.moderate"},
            {value: "3", label: "main.extensive"}
          ],
          inline: true
        },
        onChange: (ctx) => { if (ctx.state.summarize) this.write(true) }
      },
      {
        col: 12,
        name: "tone",
        type: "radioGroup",
        value: "",
        label: "main.tone",
        opts: {
          list: [
            {value: "friendly", label: "main.friendly"},
            {value: "formal", label: "main.formal"},
            {value: "professional", label: "main.professional"},
            {value: "important", label: "main.important"},
            {value: "critical", label: "main.critical"}
          ],
          inline: true
        },
        onChange: (ctx) => { if (ctx.state.tone) this.write(true) }
      },
      {
        col: 6,
        name: "inputMax",
        type: "number",
        value: "",
        label: "main.maximumCharacters",
        opts: {
          style: 'float-label'
        },
        onChange: (ctx) => { if (ctx.state.inputMax) this.postInputMax() }
      }
    ]
    this.setState({formFields: fields})
  }

  listenStatesForm = (s) => {
    this.setState({ form: s });
  }

  toogleAiModal(accept) {
    this.setState({aiModal: !this.state.aiModal}, () => {
      if (accept) this.props.ctxForm.setState({[this.props.field.name]: this.state.aiText}, () => {
        if (this.props.editor) {
          // this.editor.s.insertHTML(this.state.aiText)
          this.props.editor.value = this.state.aiText
        }
      })
    })
  }

  translate = () => {
    const { L, ctxForm, field, editor } = this.props
    ctxForm.validateFor(field.name, field.aiAssist.requiredFields).then(values => {
      const post = () => {
        let body = values
        body = {
          ...body,
          ...{
            aiAssist: {
              field: field.name,
              translate: true
            }
          }
        }
        ctxForm.props.setLoader(true)
        _axios
          .post(field.aiAssist.postUrl, body)
          .then(r => {
            ctxForm.props.setLoader(false)
            if (r.status >= 0) {
              for (const key in r.data) {
                if (r.data.hasOwnProperty(key) && r.data[key]) {
                  ctxForm.setState({[key]: r.data[key]}, () => {
                    if (field.name === key && field.type === 'editor') editor.value = r.data[key]
                  })
                }
              }
            } else NotificationManager.error(r.msg, "Opps", 5000, null, null, 'outline')
          }).catch(e => {
            ctxForm.props.setLoader(false)
          })
      }

      if (ctxForm.state[field.name]) {
        this.setState({dialog: {
          isOpen: true,
          toggle: () => {
            let d = this.state.dialog
            d.isOpen = !d.isOpen
            this.setState({dialog: d})
          },
          msg: L["main.replaceContentSelectedTextField"],
          confirm: (e) => {
            if (e) post()
            this.state.dialog.toggle()
          },
          btnOkName: "main.accept"
        }})
      } else post()
    })
    .catch(validationFailed => {
      NotificationManager.error(L["main.completeRequiredFieldsAssistantTranslate"], "Opps", 5000, null, null, 'outline')
    })
  }

  write(options) {
    const { ctxForm, field, L } = this.props
    ctxForm.validateFor(field.name, field.aiAssist.requiredFields).then(values => {
      let body = values
      body = {
        ...body,
        ...{aiAssist: {
            summarize: this.state.form?.summarize,
            tone: this.state.form?.tone,
            inputMax: this.state.form?.inputMax,
            field: field.name,    
            paragraphs: 1,
            commType: null,
            topic: null,
            seed: null
          }
        }
      }
      !options ? ctxForm.props.setLoader(true) : this.setState({progressBar: true})
      _axios
        .post(field.aiAssist.postUrl, body)
        .then(r => {
          !options ? ctxForm.props.setLoader(false) : this.setState({progressBar: false})
          if (r.status >= 0) {
            this.setState({ aiText: 'cambiooo'}, () => {
              if (!options) this.toogleAiModal()
            })
          } else {
            NotificationManager.error(r.msg, "Opps", 5000, null, null, 'outline')
          }
        }).catch(e => {
          !options ? ctxForm.props.setLoader(false) : this.setState({progressBar: false})
        })
    })
    .catch(validationFailed => {
      NotificationManager.error(L["main.completeRequiredFieldsAssistantWrite"], "Opps", 5000, null, null, 'outline')
    })
  }

  render() {
    const {L} = this.props
    return (
      <template>
        <Modal isOpen={this.state.aiModal} backdrop={'static'} wrapClassName={'modal-center'} size="md">
          <ModalHeader toggle={() => { this.toogleAiModal() }}>
            {L["main.aiAssistant"]}
          </ModalHeader>
          <ModalBody>
            <FormCustom
              id={"form-ai-assist"}
              fields={this.state.formFields}
              listenStates={this.listenStatesForm}
              validateFor={fn => this.validateFor = fn}
              resetForm={fn => this.resetForm = fn}
              didUpdateStates={true}
            />
            {this.state.progressBar && <div className="my-3 progress"><div className="indeterminate"></div></div>}
            {this.state.aiText && <h5>{L["main.suggestedText"]}</h5>}
            {this.state.aiText}
          </ModalBody>
          <ModalFooter>
            <Button outline color="secondary" size="sm" onClick={() => { this.toogleAiModal() }}>{L['main.cancel']}</Button>
            <Button color="primary" size="sm" onClick={() => { this.toogleAiModal(true) }}>{L['main.acceptSuggestion']}</Button>
          </ModalFooter>
        </Modal>
        <Dialog {...this.state.dialog}></Dialog>
      </template>
    )
  }
}